<template lang="pug">
  .root
    the-heading(:caption="'Справочники'" :breadcrumbs="breadcrumbs")
    .container
      .main_block
        .globalCaptionStyles.localCaption Справочники
        page-grid(:cols="cols" ref="grid" :response="data" :nextState="nextState" :count="count")
</template>
<script>
import TheHeading from '@/components/parts/TheHeading'
import PageGrid from '../parts/PageGrid'
import pageGridMixin from '@/mixins/pageGridMixin'
import breadcrumbs from '@/data/breadcrumbs/NSI'
import cols from '@/data/cols/nsi'
import axios from 'axios'

export default {
  components: {
    PageGrid,
    TheHeading,
    breadcrumbs
  },
  mixins: [pageGridMixin],
  data () {
    return {
      address: 'nsi/directories/?',
      api: 'dhra/api/v2/',
      breadcrumbs,
      cols,
      nextState: 'DirectorySummary'
    }
  },
  methods: {
    setData (response) {
      this.data = response.map(item => {
        return {
          id: item.id,
          name: item.short_name,
          modified_date: this.$moment(item.modified_date).format('DD MMMM YYYY')
        }
      }).filter(item => item.id !== 83 && item.id !== 84)
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/pageGridStyles.sass"
.localCaption
  margin: 40px 0 30px 40px
@media screen and (max-width: 1120px)
  .localCaption
    margin-left: 10px
</style>
